/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProvideData/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import AppointmentSlot from './AppointmentSlot/index'
import DentalPlan from './DentalPlan/index'
import Location from './Location/index'
import PatientBirthday from './PatientBirthday/index'
import PatientEmail from './PatientEmail/index'
import PatientFirstName from './PatientFirstName/index'
import PatientLastName from './PatientLastName/index'
import PatientPhone from './PatientPhone/index'
import React from 'react'
import ResponsiblePerson from './ResponsiblePerson/index'
import ResponsiblePersonEmail from './ResponsiblePersonEmail/index'
import ResponsiblePersonFirstName from './ResponsiblePersonFirstName/index'
import ResponsiblePersonLastName from './ResponsiblePersonLastName/index'
import ResponsiblePersonPhone from './ResponsiblePersonPhone/index'
import ResponsiblePersonRelationship from './ResponsiblePersonRelationship/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function ProvideData({
  children,
  viewPath = "/App/Form/Data/ProvideData"
  
}) {
  let isMedia = useIsMedia()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'DentalPlan'
  return (<React.Fragment
>
<div
  data-testid="ProvideData.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-ZEHJVI': isMedia.mobile ? "32px" : "32px",'--mt-2-ZEHJVI': isMedia.mobile ? "32px" : "48px"}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'DentalPlan'}>
<DentalPlan
  viewPath={`${viewPath}/DentalPlan`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Location'}>
<Location
  viewPath={`${viewPath}/Location`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppointmentSlot'}>
<AppointmentSlot
  viewPath={`${viewPath}/AppointmentSlot`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientFirstName'}>
<PatientFirstName
  viewPath={`${viewPath}/PatientFirstName`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientLastName'}>
<PatientLastName
  viewPath={`${viewPath}/PatientLastName`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientEmail'}>
<PatientEmail
  viewPath={`${viewPath}/PatientEmail`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientPhone'}>
<PatientPhone
  viewPath={`${viewPath}/PatientPhone`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientBirthday'}>
<PatientBirthday
  viewPath={`${viewPath}/PatientBirthday`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResponsiblePerson'}>
<ResponsiblePerson
  viewPath={`${viewPath}/ResponsiblePerson`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResponsiblePersonFirstName'}>
<ResponsiblePersonFirstName
  viewPath={`${viewPath}/ResponsiblePersonFirstName`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResponsiblePersonLastName'}>
<ResponsiblePersonLastName
  viewPath={`${viewPath}/ResponsiblePersonLastName`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResponsiblePersonEmail'}>
<ResponsiblePersonEmail
  viewPath={`${viewPath}/ResponsiblePersonEmail`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResponsiblePersonPhone'}>
<ResponsiblePersonPhone
  viewPath={`${viewPath}/ResponsiblePersonPhone`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResponsiblePersonRelationship'}>
<ResponsiblePersonRelationship
  viewPath={`${viewPath}/ResponsiblePersonRelationship`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}